<template>
  <div class="header_logo">
    <router-link :to="{name: 'Hall', params: {hallSlug: defaultHall.slug}}" class="main-logo header_logo" v-if="canShowLogo">
      <img src="/images/logo_white.png" alt="logo" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    defaultHall: {
      type: Object,
      required: true
    },
    canShowLogo: {
      type: Boolean,
      required: true
    }
  }
}
</script>
